let HasLocalData;
(function (_HasLocalData) {
  function is(model) {
    return "hasLocalData" in model;
  }
  _HasLocalData.is = is;
})(HasLocalData || (HasLocalData = {}));
export default HasLocalData;